export class BaseModel {
    
    public toJsonString(): any {
    
        //Shallow clone
        let clone: any = Object.assign({}, this); 
        //Find the getter method descriptors
        //Get methods are on the prototype, not the instance
        const descriptors = Object.getOwnPropertyDescriptors(Object.getPrototypeOf(this))
    
        //Check to see if each descriptior is a get method
        Object.keys(descriptors).forEach(key => {
            if (descriptors[key] && descriptors[key].get) {
    
                //Copy the result of each getter method onto the clone as a field
                delete clone[key];
                clone[key] = this[key]; //Call the getter
            }
        });
    
        //Remove any left over private fields starting with '_'
        Object.keys(clone).forEach(key => {
            if (key.indexOf('_') == 0) {
                let newKey = key.replace("_", "");
                clone[newKey] = clone[key]; 
                delete clone[key];
            }
        });
    
        //toJSON requires that we return an object
        return clone;
    }     
    
      public syncData(data:any) {
            if(data) {
                Object.keys(data).map((item) => {
                    if(item === "object") {
                        this[item] = {...data[item]};
                    } else {
                        this[item] = data[item];
                    }
                });
            }
      }
    
}